module.exports = __webpack_public_path__ + "img/qrcode.b88a5f15.svg";